export const navigation = [
    {
        text: 'Upload File',
        path: '/uploadfile',
        icon: 'home'
    }
  ];
